import React from "react";
import PropTypes from "prop-types";
import propTypes from "../../../../../constants/propTypes";

import DetailComponent from "./DetailComponent";
import { Cell } from "../EditableTextDetailRow/components";
import styled from "styled-components";

const column = {};

export const CustomRow = props => {
  return <StyledRow {...props} />;
};
const StyledRow = styled.tr`
  background-color: ${({ greyBackground }) =>
    greyBackground ? "rgba(0, 0, 0, 0.05) !important" : "initial !important"};

  td {
    height: 27px;
  }
`;
/**
 *
 * @param idPath
 * @param rowsSettings
 * @param validationSchema
 * @param dataComponentId
 * @param colSettings
 * @return {{DetailRowComponent: (function(*): *), WrapperDetailRow: WrapperDetailRow, RowComponent, DetailCellComponent: (function({children: *}): *)}}
 */
export const genDetailRowComponents = (
  idPath,
  rowsSettings,
  validationSchema,
  dataComponentId,
  colSettings = {},
  detailComponentProps = {}
) => {
  const DetailRowComponent = props => (
    <DetailComponent
      idPath={idPath}
      rowsSettings={rowsSettings}
      validationSchema={validationSchema}
      dataComponentId={dataComponentId}
      {...props}
      {...detailComponentProps}
    />
  );
  const WrapperDetailRow = props => {
    const greyBackground = props.row.isIncomplete || props.row.isAllowance;
    if (!colSettings.colSpan)
      return (
        <CustomRow greyBackground={greyBackground}>{props.children}</CustomRow>
      );
    const { prevSpan, posSpan } = colSettings;
    return (
      <CustomRow greyBackground={greyBackground}>
        <Cell column={column} colSpan={prevSpan} />
        {props.children}
        {posSpan > 0 && <Cell column={column} colSpan={posSpan} />}
      </CustomRow>
    );
  };

  WrapperDetailRow.propTypes = {
    children: PropTypes.arrayOf(PropTypes.shape({})),
    row: PropTypes.oneOfType([
      propTypes.spec,
      PropTypes.shape({ id: PropTypes.number }),
    ]),
  };

  const DetailCellComponent = ({ children }) => (
    <Cell column={column} colSpan={colSettings.colSpan}>
      {children}
    </Cell>
  );

  DetailCellComponent.propTypes = {
    children: PropTypes.shape({}),
  };

  return {
    DetailRowComponent,
    RowComponent: CustomRow,
    WrapperDetailRow,
    DetailCellComponent,
  };
};
